import axios from 'axios';

const instance = axios.create({
  baseURL: `${process.env.ROOT_API}/api`,
  headers: {
    // 'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
});

export default instance;



// WEBPACK FOOTER //
// ./src/shared/utils/axios-init.js